import { z } from 'zod';
import { GuestShippingAddressSchema } from '../../components/guest-address-autocomplete';

/**
 * POST /api/checkout/geocode-address
 *
 * The guest checkout's fallback for resolving the address a buyer typed when
 * the browser Maps script is not available.
 */
export const GeocodeAddressRequestSchema = z.object({
  address: z.string().trim().min(5).max(300),
});

export type GeocodeAddressRequest = z.infer<typeof GeocodeAddressRequestSchema>;

/** The street-address fields of a guest shipping address, as the component stores them. */
export const ResolvedGuestAddressSchema = GuestShippingAddressSchema.pick({
  line1: true,
  city: true,
  state: true,
  postal_code: true,
  country: true,
});

export type ResolvedGuestAddress = z.infer<typeof ResolvedGuestAddressSchema>;

export const GeocodeAddressSuccessResponseSchema = z.object({
  success: z.literal(true),
  address: ResolvedGuestAddressSchema,
});

export const GeocodeAddressErrorCodeSchema = z.enum([
  'NOT_FOUND',
  'INVALID_INPUT',
  'RATE_LIMITED',
  'METHOD_NOT_ALLOWED',
]);

export type GeocodeAddressErrorCode = z.infer<typeof GeocodeAddressErrorCodeSchema>;

export const GeocodeAddressErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  errorCode: GeocodeAddressErrorCodeSchema,
});

export const GeocodeAddressResponseSchema = z.discriminatedUnion('success', [
  GeocodeAddressSuccessResponseSchema,
  GeocodeAddressErrorResponseSchema,
]);

export type GeocodeAddressSuccessResponse = z.infer<typeof GeocodeAddressSuccessResponseSchema>;
export type GeocodeAddressErrorResponse = z.infer<typeof GeocodeAddressErrorResponseSchema>;
export type GeocodeAddressResponse = z.infer<typeof GeocodeAddressResponseSchema>;
